import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=6859f592"
import script from "./textarea.ts?vue&type=script&lang=js&external"
export * from "./textarea.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6859f592')) {
      api.createRecord('6859f592', component.options)
    } else {
      api.reload('6859f592', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=6859f592", function () {
      api.rerender('6859f592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/textarea.vue"
export default component.exports